<template>
  <div>
    <!-- Modal Edit Akun Whitelisted -->
    <BModal
      id="modal-edit-account"
      hide-footer
      hide-header
      :centered="true"
      content-class="rounded-lg"
      @shown="onShown"
      @hidden="$emit('hidden')"
    >
      <ValidationObserver #default="{ invalid }">
        <div class="p-1">
          <h1 class="text-[#333333] font-semibold text-[18px] text-center mb-2">
            Ubah Akun Whitelisted Partner
          </h1>
          <BForm>
            <div class="mb-2">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="Nama akun WL"
                vid="account_name"
              >
                <label
                  class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                >
                  Masukkan nama akun WL <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.account_name"
                  placeholder="Masukkan nama akun"
                  class="w-full"
                  :class="{ 'is-invalid': errors.length > 0 || validationError.account_name }"
                  required
                />
                <span
                  v-if="errors.length > 0 || validationError.account_name"
                  class="text-danger text-sm"
                >{{ errors[0] || validationError.account_name }}</span>
              </ValidationProvider>
            </div>

            <div
              v-if="platform === 'meta'"
              class="mb-2 space-x-[16px]"
            >
              <!-- BM ID -->
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="ID BM"
                vid="bm_id"
              >
                <label
                  class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                >
                  Masukkan ID BM <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.bm_id"
                  placeholder="Masukkan ID BM Disini"
                  class="w-full"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  required
                />
                <span
                  v-if="errors.length > 0"
                  class="text-danger text-sm"
                >{{ errors[0] }}</span>
              </ValidationProvider>

              <!-- Business Manager -->
              <ValidationProvider
                v-slot="{ errors }"
                name="Business Manager"
                rules="required"
              >
                <div class="text-left">
                  <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                    Pilih Business Manager
                    <span class="text-primary">*</span>
                  </label>
                  <BFormSelect
                    v-model="form.system_bm_id"
                    :options="metaBusinessManagerOptions"
                  />
                  <span
                    v-if="errors.length > 0 || validationError.system_bm_id"
                    class="text-danger text-sm"
                  >{{ errors[0] || validationError.system_bm_id }}</span>
                </div>
              </ValidationProvider>

              <!-- Ad Account ID -->
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|numeric"
                name="ID Ad Account"
              >
                <div class="mb-[16px] text-left">
                  <label
                    class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                  >
                    Masukkan ID Ad Account <span class="text-primary">*</span>
                  </label>
                  <BFormInput
                    v-model="form.ad_account_id"
                    placeholder="Masukkan ID Ad Account Disini"
                    class="w-full"
                    required
                  />
                  <span
                    v-if="errors.length > 0 || validationError.ad_account_id"
                    class="text-danger text-sm"
                  >
                    {{ errors[0] || validationError.ad_account_id }}
                  </span>
                </div>
              </ValidationProvider>
            </div>
            <!-- Gmail -->
            <div
              v-if="platform === 'google'"
              class="mb-2"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|email"
                name="Gmail"
                vid="gmail"
              >
                <label
                  class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                >
                  Gmail <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.gmail"
                  placeholder="Masukkan gmail Disini"
                  class="w-full"
                  type="email"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  required
                />
                <span
                  v-if="errors.length > 0"
                  class="text-danger text-sm"
                >{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <!-- BC ID -->
            <div
              v-if="platform === 'tiktok'"
              class="mb-2"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="BC ID TikTok"
                vid="bc_id"
              >
                <label
                  class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                >
                  BC ID TikTok <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.bc_id"
                  placeholder="Masukkan BC ID Disini"
                  class="w-full"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  required
                />
                <span
                  v-if="errors.length > 0"
                  class="text-danger text-sm"
                >{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <!-- Action Button -->
            <div class="flex flex-row gap-6">
              <BButton
                variant="outline-primary"
                class="rounded grow"
                @click="$bvModal.hide('modal-edit-account')"
              >
                Batal
              </BButton>
              <BButton
                :variant="!invalid && isFormValid ? 'primary' : 'secondary'"
                class="rounded grow"
                :disabled="invalid || !isFormValid"
                @click="showConfirmationModal"
              >
                Ubah Akun
              </BButton>
            </div>
          </BForm>
        </div>
      </ValidationObserver>
    </BModal>

    <!-- Modal Konfirmasi Edit Akun -->
    <BModal
      id="modal-confirm-edit-account"
      hide-footer
      hide-header
      :centered="true"
      content-class="rounded-lg"
    >
      <div class="text-center p-1">
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="Konfirmasi"
          class="mx-auto mb-2"
          width="80px"
        >
        <h1 class="font-semibold text-[18px] text-[#333333] mb-2">
          Konfirmasi Ubah Akun Whitelisted
        </h1>
        <div class="mb-2">
          <p>Perubahan akun ini akan langsung diterapkan partner</p>
        </div>
        <div class="flex flex-row gap-6">
          <BButton
            variant="outline-secondary"
            class="rounded grow"
            @click="$bvModal.hide('modal-confirm-edit-account')"
          >
            Batal
          </BButton>

          <BButton
            variant="primary"
            class="rounded grow"
            @click="editAccount"
          >
            Ya, Ubah
          </BButton>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required, email } from '@validations'
import { newAxiosIns } from '@/libs/axios'

export default {
  name: 'ModalEditAccount',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    /**
     * Account data to edit
     */
    accountData: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Backend validation errors from parent component
     */
    validationError: {
      type: Object,
      default: () => ({
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      }),
    },
    /**
     * Platform type
     */
    platform: {
      type: String,
      required: true,
      validator: value => ['meta', 'google', 'tiktok'].includes(value),
    },
  },
  data() {
    return {
      form: {
        account_name: '',
        bm_id: '',
        gmail: '',
        bc_id: '',
        system_bm_id: '',
        ad_account_id: '',
      },
      metaBusinessManagerOptions: [],
      required,
      email,
    }
  },
  computed: {
    /**
     * Check if form is valid for submission based on platform requirements
     * @returns {boolean} True if form is valid
     */
    isFormValid() {
      const hasAccountName = this.form.account_name && this.form.account_name.trim().length > 0

      const platformConfig = {
        meta: hasAccountName && this.form.bm_id && this.form.bm_id.trim().length > 0,
        google: hasAccountName && this.form.gmail && this.form.gmail.trim().length > 0,
        tiktok: hasAccountName && this.form.bc_id && this.form.bc_id.trim().length > 0,
      }

      return platformConfig[this.platform]
    },
  },
  watch: {
    /**
     * Watch for account data changes and update form
     */
    accountData: {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.form.account_name = newData.name || ''
          this.form.bm_id = newData.bm_id || ''
          this.form.system_bm_id = newData.system_bm_id || ''
          this.form.gmail = newData.gmail || ''
          this.form.bc_id = newData.bc_id || ''
          this.form.ad_account_id = newData.ad_account_id || ''
        }
      },
      deep: true,
      immediate: true,
    },
    /**
     * Reset form when platform changes
     */
    platform() {
      this.resetForm()
    },
  },

  methods: {
    /**
     * Handler executed when the component or modal is shown.
     *
     * - Only runs when the selected platform is `meta`
     *
     * @returns {void}
     */
    onShown() {
      if (this.platform !== 'meta') return
      this.form.ad_account_type = this.defaultAccountTypeKey
      this.loadSystemBusinessManagerList()
    },
    /**
     * Fetches the system Meta Business Manager list from the API.
     *
     * - Calls the system BM endpoint
     * - Maps API response into `metaBusinessManagerOptions`
     *   for select/dropdown usage
     * - Shows an error toast if the request fails
     *
     * @async
     * @returns {Promise<void>}
     */
    async loadSystemBusinessManagerList() {
      try {
        const {
          data: { data },
        } = await newAxiosIns.get('komads/api/v1/admin/system_bm/list')

        this.metaBusinessManagerOptions = [
          { value: '', text: 'Pilih Business Manager' },
          ...data.map(system => ({
            value: `${system.id}`,
            text: `${system.bm_name} - ${system.bm_id}`,
          })),
        ]
      } catch {
        this.$toast_error({
          message: 'Failed to load business manager list',
        })
      }
    },
    /**
     * Reset form to empty values
     */
    resetForm() {
      this.form.account_name = ''
      this.form.bm_id = ''
      this.form.gmail = ''
      this.form.bc_id = ''
      this.form.system_bm_id = ''
      this.form.ad_account_id = ''
    },

    /**
     * Show confirmation modal for editing account
     */
    showConfirmationModal() {
      this.$bvModal.hide('modal-edit-account')
      this.$bvModal.show('modal-confirm-edit-account')
    },

    /**
     * Edit whitelisted account
     */
    editAccount() {
      // Emit event to parent component with account data
      this.$emit('edit-account', this.form)
      // Close confirmation modal
      this.$bvModal.hide('modal-confirm-edit-account')
    },
  },
}
</script>
